import { makeModuleApiInfoSelector, makeModuleI18nSelector } from "@client/content/selectors";
import { apiAction, asyncAction } from "@client/lib/actions";
import { type AppState, type BaseAppState, type EntityRef, type GenericMap, Status } from "@client/types";
import { fields } from "@common/modules/system/index";
import { type Dispatch } from "redux";
import api from "./api";
import { localStateSelector } from "./selectors";
import { type Form } from "./types";

export enum Actions {
  GetBegin = "MODULE_FORM_GET_BEGIN",
  GetFailure = "MODULE_FORM_GET_FAILURE",
  GetSuccess = "MODULE_FORM_GET_SUCCESS",

  InitBegin = "MODULE_FORM_INIT_BEGIN",
  InitFailure = "MODULE_FORM_INIT_FAILURE",
  InitSuccess = "MODULE_FORM_INIT_SUCCESS",

  ProgressBegin = "MODULE_FORM_PROGRESS_BEGIN",
  ProgressFailure = "MODULE_FORM_PROGRESS_FAILURE",
  ProgressSuccess = "MODULE_FORM_PROGRESS_SUCCESS"
}

export type InitActionSuccessData = EntityRef & {
  emailFieldId: string;
};
export const _init = asyncAction<BaseAppState, EntityRef, InitActionSuccessData>({
  types: {
    begin: Actions.InitBegin,
    failure: Actions.InitFailure,
    success: Actions.InitSuccess
  },
  action: async (state: BaseAppState, dispatch: any, params: EntityRef) => {
    const i18n = makeModuleI18nSelector()(state, params);
    const emailFieldId = await fields.getContactProfileEmailId(i18n);
    return {
      id: params.id,
      source: params.source,
      emailFieldId
    };
  }
});

export const init = (args: EntityRef) => (dispatch: Dispatch<any>, getState: () => AppState) => {
  dispatch(_init(args));
};

export type GetBeginActionData = EntityRef & {
  formId: string;
  data?: GenericMap<any>;
};
export type GetSuccessActionData = Form.Api.GetResponse & {
  mustEnter: boolean;
};
export const _loadDetail = apiAction<BaseAppState, GetBeginActionData, Form.Api.GetResponse, GetSuccessActionData>({
  types: {
    begin: Actions.GetBegin,
    failure: Actions.GetFailure,
    success: Actions.GetSuccess
  },
  action: (state: BaseAppState, dispatch: any, params: GetBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, params);
    return api.get(apiInfo, params.formId);
  },
  mapResponse: (state: BaseAppState, resp: Form.Api.GetResponse, params: GetBeginActionData): GetSuccessActionData => {
    // const localState = makeModuleStateSelector<Form.AppState>()(state, params);
    // const firstPage = sort(
    //   resp.pages.filter((x) => x.formPageTypeKey === "Standard"),
    //   { key: "sortOrder" }
    // )[0];
    // const mustEnter =
    //   !!firstPage &&
    //   !resp.fields
    //     .filter((x) => x.formPageId === firstPage.formPageId)
    //     .some((x) => x.formFieldId === localState.emailFieldId);

    return {
      ...resp,
      mustEnter: false // !state.userInfo && !getCurrentUserId() && mustEnter,
    };
  }
});

export const loadDetail =
  (args: EntityRef, formId: string, data?: GenericMap<string>) =>
  (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
    const state = getState();

    const localState = localStateSelector(state, args);
    if (!(formId in localState.detail)) {
      dispatch(
        _loadDetail({
          ...args,
          formId,
          data
        })
      );
    }
  };

export type ProgressBeginActionData = EntityRef & {
  formId: string;
  data: GenericMap<GenericMap<any>>;
};
export type ProgressSuccessActionData = Form.Api.ProgressResponse;
export const _progress = apiAction<
  BaseAppState,
  ProgressBeginActionData,
  Form.Api.ProgressResponse,
  ProgressSuccessActionData
>({
  types: {
    begin: Actions.ProgressBegin,
    failure: Actions.ProgressFailure,
    success: Actions.ProgressSuccess
  },
  action: (state: BaseAppState, dispatch: any, params: ProgressBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, params);
    return api.get(apiInfo, params.formId);
  }
});

export const progress =
  (args: EntityRef, formId: string, data: GenericMap<GenericMap<string>>) =>
  (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
    const state = getState();

    const localState = localStateSelector(state, args);
    const detail = localState.detail[formId];
    if (detail.status !== Status.Saving) {
      dispatch(
        _loadDetail({
          ...args,
          formId,
          data
        })
      );
    }
  };
